import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campPaReorder: FaireAdCampaignEntity = {
  token: "camp_pa_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_panache_apparel",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 13000,
  startedRunningAt: "2025-03-18",
  segmentMetrics: {
    numReorderConversions: 654,
    salesDollars: 465711,
    totalAdsSpendDollars: 26906,
    returnOnAdSpend: 17.31,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-24T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
